import { isEmpty } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { DeviceSitesList } from './SitesLink';
import { DEFAULT_INVALID_VALUE } from '../../../utilities/FormattingUtilities';
import { EMPTY_ARRAY } from '../../../utilities/ConstantsUtilities';
import { useApiDataFetch } from '../../../utilities/Hooks';

export const MemoizedSitesList = React.memo(DeviceSitesList);

/**
 * Fetches sites by IP address using /query/admin/sites/whichIp endpoint.
 * Used for new/unclassified devices where the V2 device API may not include site data.
 * @param {Object} props
 * @param {string} props.ip - Device IP address to look up sites for
 */
const SitesByIp = ({ ip }) => {
    const sites = useApiDataFetch({
        endpoint: '/query/admin/sites/whichIp',
        params: { ip },
        initialState: EMPTY_ARRAY,
        dependencies: [ip],
    });

    return <MemoizedSitesList sites={sites} />;
};

SitesByIp.propTypes = {
    ip: PropTypes.string.isRequired,
};

/**
 * Displays site links for a device identified by its IP address.
 * Calls /query/admin/sites/whichIp?ip={ip} to resolve which sites contain this IP.
 * Renders the same site link list as SitesLink but uses IP-based lookup instead of device ID.
 *
 * @param {Object} props
 * @param {string} props.ip - Device IP address
 * @returns {JSX.Element} List of site links or default placeholder
 */
const SitesLinkByIP = ({ ip }) => {
    if (isEmpty(ip)) {
        return <>{DEFAULT_INVALID_VALUE}</>;
    }

    return <SitesByIp ip={ip} />;
};

SitesLinkByIP.propTypes = {
    ip: PropTypes.string.isRequired,
};

export default SitesLinkByIP;
